import React from "react";
import { Navigation } from "../components/navigation";
import { Header } from "../components/header";
import { Features } from "../components/features";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import { Testimonials } from "../components/testimonials";
import { Contact } from "../components/contact";
import engineeringData from "../data/engineering.json";


const EngineeringSolutions = () => {
  return (
    <div>
      <Navigation />
    <Header data={engineeringData.Header} />
<About data={engineeringData.About} />
<Services data={engineeringData.Services} />
{/* <Gallery data={engineeringData.Gallery} /> */}
<Testimonials data={engineeringData.Testimonials} />
<Contact data={engineeringData.Contact} />

    </div>
  );
};

export default EngineeringSolutions;
